import { clsx } from 'clsx';
import { type FC, type PropsWithChildren, type SyntheticEvent } from 'react';

import styles from './Controls.css';

export type ControlsProps = {
  onClick?: (e: SyntheticEvent) => void;
};

export const Controls: FC<PropsWithChildren<ControlsProps>> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};

export const ControlsShort: FC<PropsWithChildren<ControlsProps>> = ({ children }) => {
  return <div className={styles['container-short']}>{children}</div>;
};

type ControlWrapperProps = ControlsProps & {
  visible?: boolean;
};

export const ControlWrapper: FC<PropsWithChildren<ControlWrapperProps>> = ({ children, visible, onClick }) => (
  <div className={clsx(styles['wrapper'], visible && styles['visible'])} onClick={onClick}>
    {children}
  </div>
);
